// Disabling `console` logging statements in prod page. 
if(window.location.hostname === "bottlenose.aws.a2z.com") {
  var console = {};
  console.debug = function(){};
  console.error = function(){};
  console.info = function(){};
  console.log = function(){};
  console.warn = function(){};
}

import React from 'react';
import ReactDOM from 'react-dom';
import '@amzn/awsui-components-react/index.css';
// import 'AWS-UI-Components/grid.css';
// import 'AWS-UI-Components/utils.css';
import '../assets/styles/index.css';
import '../assets/styles/custom.css';

import AuthControl from './AuthControl'

ReactDOM.render(
  <AuthControl/>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/app/index.js